import React, { createContext, useEffect, useRef, useState } from 'react';
import api from '../services/api';
export const ClientsContext = createContext({});

function ClientsProvider({ children }) {

    const [data,setData] = useState([])
    const [count,setCount] = useState()
    
    const getAll = async () => {
        const response = await api.get("panel/get/all/users/")

        if(response.status == 200){
            setData(response.data)
        }

    }
    const getDashboard = async () => {
        const response = await api.get("panel/get/all/users/dashboard")
        if(response.status == 200){
            setCount(response.data.count)
        }

    }

    useEffect(() => {
        getDashboard()
    },[])

 

    return (
        <ClientsContext.Provider value={{
        getAll,
        data,
        getDashboard,
        count
        }}>
            {children}
        </ClientsContext.Provider>
    );
}

export default ClientsProvider;
